'use strict';
/*
 * GANTI RUGI GALON — the rules for recording one, shared by the server and the browser.
 *
 * The office form previews a plan (what lands in Sisa Bon, whether a negotiated price waits for ACC,
 * whether a transfer still waits for its proof) and the server writes exactly that plan. Both run THIS
 * file, so the preview can never disagree with what is saved (owner decisions 2026-10-26).
 *
 * The ganti rugi row always keeps amount = qty × harga pemilik. A negotiated total only applies through an
 * approved price correction; money received at another figure is a separate payment row.
 *
 * Loaded as `window.DISTGR` in the browser bundle AND require()d by the server.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;   // server (CommonJS)
  if (root) root.DISTGR = api;                                                 // browser (global)
})(typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : this), function () {
  function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }

  // o = { qty, ownerPrice, total (null → qty × ownerPrice), pay: tunai|transfer|bon|ganti_galon,
  //       hasTransferProof, office, canNego (holds distribusiGantiRugiHarga), selfLimit (0 = unlimited) }
  function planGantiRugi(o) {
    var qty = Math.max(0, Math.round(num(o.qty)));
    var price = Math.max(0, Math.round(num(o.ownerPrice)));
    var pay = o.pay;
    var money = pay !== 'ganti_galon';
    var ownerAmount = money ? qty * price : 0;
    // the field always charges the owner's price; only the office may type another total
    var amount = !money ? 0 : (o.office && o.total != null && o.total !== '' ? Math.round(num(o.total)) : ownerAmount);
    var nego = !!(o.office && money && amount !== ownerAmount);
    var limit = Math.max(0, num(o.selfLimit));
    var negoApplyNow = !!(nego && o.canNego && (limit === 0 || amount <= limit));
    var paidNow = pay === 'tunai' || (pay === 'transfer' && !!o.hasTransferProof);
    var transferPending = pay === 'transfer' && !o.hasTransferProof;
    var out = { ownerAmount: ownerAmount, amount: amount, nego: nego, negoApplyNow: negoApplyNow,
      parentMethod: 'lunas', parentPayMethod: '', transferPending: false, settleNow: 0, sisaBonAdd: 0, blocked: '' };
    if (!money) { out.parentPayMethod = 'ganti_galon'; return out; }
    if (!price) { out.blocked = 'gr.errNoPrice'; return out; }
    if (amount <= 0) { out.blocked = 'gr.errTotal'; return out; }
    if (!nego) {
      if (paidNow) { out.parentPayMethod = pay; return out; }
      out.parentMethod = 'bon'; out.transferPending = transferPending; out.sisaBonAdd = ownerAmount;
      return out;
    }
    // a negotiated total: the row stays a bon at the owner's price until the ACC; money paid now is a payment
    // row. Paying MORE than the owner's price before the ACC would settle a debt that does not exist yet.
    if (paidNow && amount > ownerAmount && !negoApplyNow) { out.blocked = 'gr.errNegoAbove'; return out; }
    out.parentMethod = 'bon';
    out.transferPending = transferPending;
    out.settleNow = paidNow ? amount : 0;
    out.sisaBonAdd = (negoApplyNow ? amount : ownerAmount) - out.settleNow;
    return out;
  }

  // A transfer proof attached later settles what is still owed on that ganti rugi — never more than the
  // customer's Sisa Bon (a Pembayaran Bon may already have paid part of the pool).
  function proofSettleAmount(o) { return Math.max(0, Math.min(num(o.outstanding), num(o.sisaBon))); }

  // The part of a ganti rugi put on bon that was NOT paid the same day ("Masuk bon" on the dashboard).
  function bonPartOnDay(effective, sameDaySettled) { return Math.max(0, num(effective) - num(sameDaySettled)); }

  return { planGantiRugi: planGantiRugi, proofSettleAmount: proofSettleAmount, bonPartOnDay: bonPartOnDay };
});
